import type { Player, PlayerId } from '../api/types';
import type { DraftMatch } from '../domain/matchSchedule';
import type { PenaltyType } from '../domain/penalties';
import type { PointsRow } from '../reducers/points';
import { ensureErrorMessagesArray } from './common';
import type { Messages } from './common';
export function pointsNextStep() {
  return {
    type: 'POINTS_NEXT_STEP'
  };
}
export function pointsPreviousStep() {
  return {
    type: 'POINTS_PREVIOUS_STEP'
  };
}
// Sets per Player. The set count is their sum, which is exactly the invariant the backend
// checks, so the two can no longer disagree.
export function setMatchScore(matchId: number, player1Score: number, player2Score: number) {
  return {
    type: 'SET_MATCH_SCORE',
    matchId,
    player1Score,
    player2Score
  };
}
export function pointsNextStepExpanded(expandedResults: DraftMatch[]) {
  return {
    type: 'POINTS_NEXT_STEP_EXPANDED',
    expandedResults
  };
}
export function setDateTime(dateTime: string) {
  return {
    type: 'POINTS_SET_DATETIME',
    dateTime
  };
}
export function getAllActiveUsers() {
  return {
    type: 'POINTS_GET_ALL_ACTIVE_USERS'
  };
}

export function pointsGetAllActiveUsersSuccess(usersArray?: Player[]) {
  const users = Array.isArray(usersArray) ? usersArray : [];
  return {
    type: 'POINTS_USERS_GET_ALL_ACTIVE_SUCCESS',
    users
  };
}
export function pointsGetAllActiveUsersFail() {
  return {
    type: 'POINTS_USERS_GET_ALL_ACTIVE_FAIL',
    message: {
      messages: ['Nie można pobrać użytkowników'],
      type: 'fail',
    }
  };
}
export function addUserToPoints(user: Player) {
  return {
    type: 'POINTS_ADD_USER_TO_POINTS',
    user
  };
}
export function removeUserFromPoints(user: Player) {
  return {
    type: 'POINTS_REMOVE_USER_FROM_POINTS',
    user
  };
}
export function comment(text: string) {
  return {
    type: 'SAVE_COMMENT',
    text
  };
}
export function penalty(userId: PlayerId, penaltyStatus: boolean, penaltyType: PenaltyType) {
  return {
    type: 'POINTS_USER_PENALTY',
    userId,
    penaltyStatus,
    penaltyType
  };
}
export function saveMatchDayRequest() {
  return {
    type: 'POINTS_SAVE_REQUEST'
  };
}
export function matchDaySaved(results: PointsRow[], monthPoints: PointsRow[]) {
  return {
    type: 'POINTS_SAVE_SUCCESS',
    results,
    monthPoints
  };
}
export function matchDayNotSaved(messages?: Messages) {
  return {
    type: 'POINTS_SAVE_FAIL',
    errorMessages: ensureErrorMessagesArray(messages)
  };
}
export function sendEmailSuccess() {
  return {
    type: 'ADMIN_POINTS_SEND_EMAIL_SUCCESS',
    message: { text: 'Email sent' }
  };
}
export function sendEmailFailure() {
  return {
    type: 'ADMIN_POINTS_SEND_EMAIL_FAILURE',
    message: { text: 'Email not sent' }
  };
}
